import React from 'react';

type CalendarProps = {
  name?: string;
  email?: string;
  calendar_key: string;
};

function Calendar({ name, email, calendar_key }: CalendarProps) {
  return (
    <iframe
      title={calendar_key}
      src={`https://go.oncehub.com/${calendar_key}?name=${encodeURIComponent(
        name || ''
      )}&email=${encodeURIComponent(email || '')}&em=1&soskip=1&topic=noa-test`}
      id={`SOI_${calendar_key}`}
      name="ScheduleOnceIframe"
      scrolling="no"
      style={{
        maxWidth: '100%',
        margin: '0px auto',
        position: 'initial',
        width: '100%',
        minHeight: '480px',
        height: 'auto',
        border: '0',
      }}
      width="100%"
      height="auto"
    ></iframe>
  );
}

export default Calendar;
